export { default } from './InternetFormModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Internet/InternetFormModal/index.js